export default __webpack_public_path__ + "static/media/acxiom.07612176.csv";